import React from 'react';
import LoginForm from '../../components/User/Login/login';

const Login = () => <LoginForm />;

export default Login;
